module.exports = __webpack_public_path__ + "static/img/11.82c6974.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/11.png
// module id = y8J+
// module chunks = 0